import gql from 'graphql-tag'

export default gql`
  query unreadNotifications($id: ID!, $excludeFilters: [[NotificationFilter]]) {
    unreadNotifications(id: $id, excludeFilters: $excludeFilters) {
      count
    }
  }
`
